module.exports = __webpack_public_path__ + "img/structure.4ec20ac8.svg";